import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { BankDetails } from './bank-details.model';

export const ACH_CREDIT_BANK_DETAILS_SCHEMA = Object.freeze({
  STRIPE: BankDetails,
});
const RECORD = generateSchema(ACH_CREDIT_BANK_DETAILS_SCHEMA);
const KEYS: any = generateKeys(ACH_CREDIT_BANK_DETAILS_SCHEMA);

export class AchCreditBankDetails extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.STRIPE,
        value: new BankDetails(this.stripe),
      },
    ]);

    return selfModel as AchCreditBankDetails;
  }

  get stripe(): BankDetails {
    return this.get(KEYS.STRIPE);
  }
}
